import ExternalBlogTags from './ExternalBlogTags';

export default ExternalBlogTags;


// WEBPACK FOOTER //
// ./src/components/Query/ExternalBlog/index.ts